export default __webpack_public_path__ + "static/media/heraldofxotliaction.1736edf0.png";